<script>
import InputFieldContact from "@/components/input/InputFieldContact.vue";
import {toast} from "vue3-toastify";

export default {
  name: 'VisiteView',
  components: {InputFieldContact},
  data () {
    return {
      formData: {}
    }
  },
  methods: {
    submitForm () {
      this.formData = {}
      toast("Nous avons pris en compte de demande de visite, nous reviendrons vers vous rapidement")
    }
  }
}
</script>

<template>
  <section class="bg-white dark:bg-gray-900">
    <!-- components 1 -->
    <div class="min-h-screen">
      <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        <h1 class="my-4 text-4xl lg:text-8xl font-sigmar tracking-wider text-primary-700 uppercase font-extrabold leading-none">
          visitez notre <br> brassserie
        </h1>
        <h2 class="uppercase font-bold text-xl text-primary-700/80 mt-10">Planifier votre visite</h2>
        <p class="text-primary-700/80">Découvrez le monde merveilleux de la brasserie déglingo.</p>
      </div>
      <div class="flex mx-auto justify-between lg:justify-center">
        <a
              href="#planning"
            title="Programmer une visite"
            class="button mr-5 border-2 font-bold text-primary-700 hover:text-white uppercase border-primary-700 hover:bg-primary-300 rounded-full text-sm px-7 py-4 relative text-center inline-flex items-center"
        >
          Planifier une visite
          <i class="fa-solid fa-right-long ml-3"></i>
        </a>
        <a
            href="#info"
            title="Voir plus d'infos"
            class="button mr-5 border-2 font-bold text-primary-700 hover:text-white uppercase border-primary-700 hover:bg-primary-300 rounded-full text-sm px-7 py-2.5 relative text-center inline-flex items-center"
        >
          Plus d'infos
          <i class="fa-solid fa-right-long ml-3"></i>
        </a>
      </div>
    </div>
    <!-- components 1 -->
    <div class="relative">
      <img class="absolute top-0 w-3/4 lg:w-1/4 left-1/2 -translate-x-1/2 -translate-y-3/4" src="../assets/glingo.png" alt="Glingo notre mascotte">
    </div>
    <!-- components 2 -->
    <div class="w-full bg-primary-700 min-h-screen flex flex-col items-center justify-center">
      <h1 class="my-4 text-4xl lg:text-8xl font-sigmar tracking-wider text-white text-center uppercase font-extrabold leading-none">
        bienvenue <br> dans <br> notre habitat
      </h1>
      <h2 class="text-center text-white text-2xl uppercase my-8">
        Là où Glingo est dans son élément.
      </h2>
      <p class="text-white text-center w-full lg:w-1/2 mx-auto my-5">
        Dès l'instant où vous pénétrez dans le bâtiment orange de Déglingo, vous entrez dans notre univers complètement dingo.
        Vous serez accueillis par nos guides expérimentés qui vous plongeront dans l'histoire de
        notre brasserie et le processus de production de nos bières. À la fin de la visite vous attendra une
        délicieuse dégustation où nous dévoilerons tous nos secrets et si vous êtes chanceux glingo vous offrira une bière personnalisée.
      </p>
      <a
          href="#planning"
          title="Programmer une visite"
          class="button mr-5 border-2 font-bold text-white hover:text-primary-700 uppercase border-white hover:bg-white rounded-full text-sm px-7 py-4 relative text-center inline-flex items-center"
      >
        Planifier une visite
        <i class="fa-solid fa-right-long ml-3"></i>
      </a>
    </div>
    <div class="hidden lg:block w-full h-96 bg-primary-700"></div>
    <!-- components 2 -->

    <!-- components 3 -->
    <div class="min-h-screen relative">
      <div class="relative lg:absolute w-full lg:w-2/3 lg:left-1/2 lg:-translate-y-2/4 lg:-translate-x-1/2 lg:h-full flex flex-wrap">
        <div class="w-full lg:w-1/2 h-full p-1 flex items-center">
          <img src="../assets/cuve.jpg" alt="Image cuve">
        </div>
        <div class="flex flex-col w-full lg:w-1/2 h-full">
          <div class="w-full h-1/2 p-1">
            <img src="../assets/brasserie_1.webp" class="object-cover w-full h-full" alt="Image de la brasserie">
          </div>
          <div class="w-full h-1/2 p-1">
            <img src="../assets/brasserie_2.webp" class="object-cover w-full h-full" alt="Image de la brasserie">
          </div>
        </div>
      </div>
    </div>
    <!-- components 3 -->

    <!-- components 4 -->
    <div id="info" class="min-h-screen">
      <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        <h1 class="my-4 text-4xl lg:text-8xl font-sigmar tracking-wider text-primary-700 uppercase font-extrabold leading-none">
          infos pratiques
        </h1>
        <h2 class="uppercase font-bold text-2xl text-primary-700/80 mt-20 mb-5">
          horaire d'ouverture
        </h2>
        <p class="text-primary-700/80">
          La brasserie se visite du lundi au samedi, sur réservation.
        </p>
        <h2 class="uppercase font-bold text-2xl text-primary-700/80 mt-10 mb-5">
          Prix
        </h2>
        <p class="text-primary-700/80 w-full lg:w-1/2 mx-auto">
          20 euros/personne (groupes d'au moins 15 personnes).
          Pour les plus petits groupes : 140 € minimum. Si c'est possible, vous pouvez vous joindre à une visite
          déjà programmée. Merci de remplir notre forme.
          <br><br><br>
          Entrée: 69 rue de la bière , 6969 BiereLand
        </p>
      </div>
    </div>
    <!-- components 4 -->

    <div id="planning" class="bg-primary-700 w-full min-h-screen flex flex-wrap lg:flex-nowrap items-center justify-between px-5 lg:px-10">
      <div class="w-full lg:w-2/5 mt-5">
        <h1 class="text-4xl lg:text-8xl font-sigmar tracking-wider font-bold text-white mb-4">Réservez <br> à présent</h1>
        <h2 class="text-3xl text-white font-extrabold">Bon à savoir</h2>
        <p class="text-lg mb-6 w-full text-white mt-10">
          Faites votre demande de visite en remplissant le formulaire ci-dessous.
          L'envoi de ce formulaire n'est pas définitif. Un e-mail de confirmation vous sera envoyé.
        </p>
      </div>
      <div class="bg-white shadow-xl w-full lg:w-3/5 rounded-3xl lg:mx-5 p-6">
        <h2 class="text-primary-700 uppercase text-xl font-extrabold text-center">
          Remplissez vos coordonnées et choisissez une date
        </h2>
        <div class="space-y-4 mt-12">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <input-field-contact
              v-model="formData.name"
              type="text"
              icon="fa-solid fa-user-pen"
              placeholder="Nom et prénom"
            />
            <input-field-contact
                v-model="formData.phone"
                type="phone"
                icon="fa-solid fa-phone"
                placeholder="Numéro de téléphone"
            />
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <input-field-contact
                v-model="formData.email"
                type="email"
                icon="fa-solid fa-envelope"
                placeholder="Adresse email"
            />
            <input-field-contact
                v-model="formData.nombre"
                type="number"
                icon="fa-solid fa-users"
                placeholder="Nombre de personnes"
            />
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <input-field-contact
                v-model="formData.day"
                type="date"
                icon="fa-solid fa-calendar-days"
                placeholder="Jour de visite"
            />
            <input-field-contact
                v-model="formData.hour"
                type="time"
                icon="fa-solid fa-clock"
                placeholder="Heure de visite"
            />
          </div>
          <textarea
              placeholder="Message ou question*"
              class="border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="4"
          ></textarea>

          <div class="g-recaptcha" data-sitekey="votre-clé-recaptcha"></div>

          <button @click="submitForm" class="button mr-5 border-2 font-bold text-primary-700 hover:text-white uppercase border-primary-700 hover:bg-primary-300 rounded-full text-sm px-7 py-4 relative text-center inline-flex items-center">
            Envoyer
            <i class="fa-solid fa-right-long ml-3"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

